/**
 * SaveDraftIndicator — F-003.2 Phase 3 (IMPL-P3-001).
 *
 * Status pill per l'autosave del draft. 4 stati:
 *  - idle:   null (nessun output)
 *  - saving: spinner + "Salvataggio…"
 *  - saved:  check verde + "Salvato"
 *  - error:  x rosso + "Errore di salvataggio"
 *
 * role="status" + aria-live="polite": annuncia il cambiamento senza
 * interrompere la lettura corrente dello screen reader.
 */
import { Check, Loader2, X } from 'lucide-react';
import type { DraftStatus } from '../../hooks/useContractForm';

export interface SaveDraftIndicatorProps {
  status: DraftStatus;
}

export function SaveDraftIndicator({ status }: SaveDraftIndicatorProps) {
  if (status === 'idle') return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="flex items-center gap-1.5 text-sm"
    >
      {status === 'saving' && (
        <>
          <Loader2
            className="h-4 w-4 animate-spin text-muted-foreground"
            aria-hidden="true"
          />
          <span className="text-muted-foreground">Salvataggio…</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Check className="h-4 w-4 text-emerald-600" aria-hidden="true" />
          <span className="text-emerald-600">Salvato</span>
        </>
      )}
      {status === 'error' && (
        <>
          <X className="h-4 w-4 text-destructive" aria-hidden="true" />
          <span className="text-destructive">Errore di salvataggio</span>
        </>
      )}
    </div>
  );
}
